import { FormBuilder } from '@angular/forms';
import { CustomFormControl, CustomFormControlDefinition } from '@mpt-fo/common/shared/utils/custom-form-control';
import { BaseFormComponent } from '@mpt-fo/common/lean-shared/components/base-form/base-form.component';
import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-device-registration',
	templateUrl: './device-registration.component.html',
	styleUrls: ['./device-registration.component.scss']
})
export class DeviceRegistrationComponent extends BaseFormComponent implements OnInit {
	otpControl: CustomFormControlDefinition;

	constructor(
		private fb: FormBuilder
	) {
		super(fb);
		this.otpControl = new CustomFormControl()
			.id('otp')
			.placeholder('Enter OTP')
			.name('OTP')
			.isOTP()
			.type('password')
			.isRequired()
			.build();

		this.form = this.fb.group({
			otpControl: this.otpControl.formGroupControl,
		});
	}

	ngOnInit(): void {
	}


	next() {
		if (!this.validateForm()) { return; }
	}

}
